.et{background-color:inherit;}